<template>
    <div class="row marketing">
      <div class="col-lg-12">
        <p>{{chapterdata.assignmentDescription}}</p>
        <strong>Assignment:</strong><br>
        <div v-html="chapterdata.assignment"></div><br>
          <div style="padding-bottom:1em">
          <b style="color:#6ad5bf"><i>Earn!</i>
          <span style="color:#f2c300;">{{chapterdata.assignmentPoints}}</span>
          <span style="margin-top: -4px; margin-left: -4px;" class="coinicon3"></span>
          </b>
          <br>
          <div style="color:rgba(0,0,0,.2)">
            <span>Rating criteria:</span>
            <div  v-for="criteria in chapterdata.assignmentRatingCriteria">
              <span >✓ {{criteria}}</span>
            </div>
          </div>

        </div>
      </div>
      <div  v-if="getSubmission" class="col-lg-12">
        <div v-if="getReview">
          <div style="margin-bottom:1em">
            <div class="user-answer-review">
              <div style="padding-bottom: 1em; color: rgba(0,0,0,.54);">
                <span style="font-size: 1em;">Your Submission:</span></b>
                <span class="card-date">{{ new Date(getSubmission.date).toDateString() }}</span><br>
                <span style="color: rgba(0,0,0,.2);">Rating: </span>
                <span style="color:#f2c300; font-weight:bold;"> {{getReview.rating}}<span style="color:rgba(242, 195, 0, .4)">/{{getSubmission.assignmentPoints}}</span> 
                <span style="margin-top: -4px; margin-left: -4px;" class="coinicon3"></span></span>

                <!--<span class="badge badge-primary" style="font-size: 0.9em;">{{getReview.rating}} / {{getSubmission.assignmentPoints}}</span>-->
              </div>
              <i style="white-space: pre-wrap">{{getSubmission.content}}</i>
            </div> 
            
            <div class="review-assessment">
              <div style="padding-bottom: 2em; color: rgba(0,0,0,.54);">
                <span class="card-date">{{ new Date(getReview.date).toDateString() }}</span>
                <span style="font-size: 1em;">Review</span> by <b>{{ getReview.reviewDisplayName }}</b>:
  
              </div>
              <div style="color:rgba(0,0,0,.80)" v-html="getReview.content"></div>
            </div>   
          </div>
          <div style="margin-bottom:2em">
            <i style="color:rgba(0,0,0,.2); font-weight:bold">If you have an idea how to improve this review please write us on <a style="color:rgba(0,0,0,.4)" href="https://t.me/dacade">telegram</a> we are very grateful for all feedback.</i>
          </div>
        </div>

        
        <!--If no review on submission-->
        <div v-else>
            <div class="user-answer-review">
              <div style="padding-bottom: 1em; color: rgba(0,0,0,.54);">
                <span style="font-size: 1em;">Your Submission:</span></b>
                <span class="card-date">{{ new Date(getSubmission.date).toDateString() }}</span>
              </div>
              <i style="white-space: pre-wrap">{{getSubmission.content}}</i>
            </div>          

            <div class="alert alert-warning alert-dismissible fade show" role="alert">
              <strong>Reviews pending</strong> There are no reviews on your submission yet. We estimate that it will take less than 24 hours until your submission will receive feedback. We will notify you by email once you have received feedback.
            </div>
        </div>

        <a class="btn btn-outline-primary btn-lg btn-block" style="margin-top:2em;" @click="NextChapterView(chapterdata)">See Peers</a>
      </div>
    
    <!--If no submissions-->
      
    <div v-else class="col-lg-12"> 
      <form>
          <span style="font-size: 1em; color:rgba(0,0,0,.2); float:right; margin-bottom:2px; font-weight:bold">{{getCharacter}} <span style="font-weight:400">Words</span></span>
          <div class="form-group row" style="clear:right">
            <label for="message-text" class="col-form-label" style="font-size: 1em"></label>
            <textarea class="form-control" id="message-text" placeholder="Enter your submission here" rows="12" v-model="submission.content"></textarea>
          </div>
          <div style="margin-bottom:2em">
            <i style="color:rgba(0,0,0,.2); font-weight:bold">If you have any questions regarding this assignment we are happy to answer it on <a style="color:rgba(0,0,0,.4)" href="https://t.me/dacade">telegram</a>.</i>
          </div>
          <a class="btn btn-outline-primary btn-lg btn-block" @click="addSubmission(chapterdata)">Submit</a>
      </form> 
    </div>
  </div>
</template>


<script>
import { dbSubmissionsRef } from '../../../firebaseConfig'
import { dbReviewsRef } from '../../../firebaseConfig'
import { store } from '../../../store/store.js'

 export default {
  props:['chapterdata'],
  data() {
    return {
        submission:{
          userId:'',
          displayName: '',
          content:'',
          chapterId: this.chapterdata.id,
          lCId: this.chapterdata.lCId,
          assignment:this.chapterdata.assignment,
          assignmentRatingCriteria:this.chapterdata.assignmentRatingCriteria,
          assignmentPoints:this.chapterdata.assignmentPoints,
          assignmentBounty:this.chapterdata.assignmentBounty,
          date: Date.now()
        },
        currentUserAll: this.$store.getters.currentUser
    }
  },
  computed: {
      currentUser(){
        return this.submission.userId = this.$store.getters.currentUser.uid;
      },
      getSubmission() {
          var subdata = this.$store.getters.getSubmission2;
          if(subdata && this.currentUser){
              var chapterSubmission = subdata.filter( submission => {
                  return  (submission.chapterId == this.chapterdata.id && submission.userId == this.currentUserAll.uid );
              });
              return chapterSubmission[0];
          }
      },
      getReview() {
          var subdata2 = this.$store.getters.getReviews;
          //console.log("subdata2")
          //console.log(subdata2)
          if(subdata2 && this.currentUserAll){
              var chapterReview = subdata2.filter( review => {
                  return  (review.chapterId == this.chapterdata.id && review.submissionUserId == this.currentUserAll.uid );
              });
              //console.log(chapterReview);
              return chapterReview[0];
          }
      },
      getCharacter() {
        if (this.submission.content.length>0){
          var words = this.submission.content.trim().split(/\s+/).length;
        } else {
          var words = 0
        }
        return words
      }
      
  },    

  methods: {
    addSubmission(chapterdata) {
      this.submission.displayName = this.currentUserAll.displayName;
      if (this.getCharacter < 25){
        alert("Your answer is too short please be more explicit.")
      }else{
        dbSubmissionsRef.push(this.submission)
      }
      //console.log(this.getCharacter)
      //var submissionAssignment = this.getSubmission;
      // console.log(submissionAssignment)

      //this.$router.push({path: '/course/' + chapterdata.lCId + '/chapter/' + chapterdata.id + '/review/'});
    },
    NextChapterView(chapterdata) {
      this.$router.push({path: '/course/' + chapterdata.lCId + '/chapter/' + chapterdata.id + '/allReviews/'});
    },

      
  },
  created() {
    this.$store.dispatch('setReviewsRef', dbReviewsRef)
  }
 }
</script>

<style scoped>
.user-answer-review {
    border-radius: .3rem;
    background-color: #E1F6F2;
    padding: 1em;
    margin-bottom: 1em;
}

.row {
    margin-right: 0px;
    margin-left: 0px;
}

.card-date {
    color: rgba(0,0,0,.2);
    float: right;
}

.alert-warning {
    color: rgba(0,0,0,.6);
    background-color: #fff3cd;
    border-color: #ffeeba;
}
</style>


// WEBPACK FOOTER //
// src/components/course/chapter/ChapterAssignment.vue